/*
 * Warenkorb-Anreiz (winterkids): zeigt je nach Artikelanzahl den nächsten Mengenrabatt
 * und bietet "+ 1 dazu" an. Nutzt ausschließlich vorhandene Theme-Funktionen:
 *  - Warenkorbseite / Cart Drawer: CartItems.updateQuantity() (aktualisiert Liste, Summen, Zähler)
 *  - Bestätigungs-Pop-up: /cart/add + CartNotification.renderContents() + Pub/Sub "cart-update"
 * Den Rabatt selbst zieht Shopify über die automatischen Rabatte ab.
 */
if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      connectedCallback() {
        this.titleEl = this.querySelector('[data-cart-upsell-title]');
        this.textEl = this.querySelector('[data-cart-upsell-text]');
        this.button = this.querySelector('[data-cart-upsell-button]');
        this.buttonText = this.querySelector('[data-cart-upsell-button-text]');
        this.errorEl = this.querySelector('[data-cart-upsell-error]');
        this.state = {
          count: parseInt(this.dataset.count, 10) || 0,
          variant: this.dataset.variant,
          qty: parseInt(this.dataset.qty, 10) || 0,
          price: parseInt(this.dataset.price, 10) || 0,
          total: parseInt(this.dataset.total, 10) || 0,
        };
        this.picker = this.querySelector('[data-cart-upsell-picker]');
        this.selects = this.picker ? Array.from(this.picker.querySelectorAll('select')) : [];
        try {
          const el = this.querySelector('[data-cart-upsell-variants]');
          this.variants = el ? JSON.parse(el.textContent) : [];
        } catch (e) {
          this.variants = [];
        }
        this.userPicked = false;
        this.selects.forEach((s) =>
          s.addEventListener('change', () => {
            this.userPicked = true;
            this.errorEl.hidden = true;
          })
        );
        this.onClick = this.onClick.bind(this);
        this.button.addEventListener('click', this.onClick);
        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
        this.render();
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        clearTimeout(this.refreshTimer);
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '{{amount_with_comma_separator}} €';
        const [int, dec] = (cents / 100).toFixed(2).split('.');
        const sep = (s) => int.replace(/\B(?=(\d{3})+(?!\d))/g, s);
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
          if (key === 'amount_with_comma_separator') return `${sep('.')},${dec}`;
          if (key === 'amount_no_decimals_with_comma_separator') return sep('.');
          if (key === 'amount_no_decimals') return sep(',');
          return `${sep(',')}.${dec}`;
        });
      }

      refresh() {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => {
          const url = `${(window.routes && window.routes.cart_url) || '/cart'}.js`;
          fetch(url, { headers: { Accept: 'application/json' } })
            .then((r) => (r.ok ? r.json() : null))
            .then((cart) => {
              if (!cart) return;
              const first = cart.items && cart.items[0];
              this.state = {
                count: cart.item_count,
                variant: first ? String(first.variant_id) : '',
                qty: first ? first.quantity : 0,
                price: first ? first.original_price : 0,
                total: cart.original_total_price || 0,
              };
              this.render();
            })
            .catch(() => {});
        }, 80);
      }

      render() {
        const { count, price } = this.state;
        const pct2 = parseFloat(this.dataset.pct2) || 0;
        const pct3 = parseFloat(this.dataset.pct3) || 0;
        this.errorEl.hidden = true;

        if (count <= 0 || (count === 1 && !pct2) || (count === 2 && !pct3)) {
          this.hidden = true;
          return;
        }
        this.hidden = false;
        this.classList.toggle('cart-upsell--done', count >= 3);

        if (this.picker) this.picker.hidden = count >= 3;
        this.syncPicker();
        if (count >= 3) {
          this.titleEl.textContent = (this.dataset.done || '').replace('[pct]', `${pct3} %`);
          this.textEl.textContent = '';
          this.textEl.hidden = true;
          this.button.hidden = true;
          return;
        }
        const next = count + 1;
        const pct = next === 2 ? pct2 : pct3;
        // Ersparnis auf ALLE Paare: aktueller Warenkorbwert + ein weiteres Paar der zuletzt gewählten Variante
        const base = (this.state.total || price * count) + price;
        const raw = (base * pct) / 100; const fl = Math.floor(raw); const saving = Math.abs(raw - fl - 0.5) < 1e-9 ? (fl % 2 === 0 ? fl : fl + 1) : Math.round(raw);
        const tpl = count === 1 ? [this.dataset.title1, this.dataset.text1] : [this.dataset.title2, this.dataset.text2];
        this.titleEl.textContent = tpl[0] || '';
        this.textEl.textContent = (tpl[1] || '').replace('[amount]', this.formatMoney(saving)).replace('[pct]', `${pct} %`);
        this.textEl.hidden = false;
        this.button.hidden = false;
        if (!this.busy) this.buttonText.textContent = this.dataset.button || '+ 1 dazu';
      }

      /* Auswahl für "+ 1 dazu": startet mit der Variante im Warenkorb, bis die Kundin selbst wählt */
      syncPicker() {
        if (!this.selects.length || this.userPicked) return;
        const v = this.variants.find((x) => String(x.id) === String(this.state.variant));
        if (!v) return;
        this.selects.forEach((s) => {
          s.value = v.options[parseInt(s.dataset.optionIndex, 10)];
        });
      }

      selectedVariant() {
        if (!this.selects.length) return { id: Number(this.state.variant), available: true };
        const values = this.selects.map((s) => s.value);
        return this.variants.find((v) => v.options.every((o, i) => o === values[i])) || null;
      }

      setBusy(busy) {
        this.busy = busy;
        this.button.classList.toggle('loading', busy);
        this.button.setAttribute('aria-disabled', busy ? 'true' : 'false');
        this.button.querySelector('.loading__spinner')?.classList.toggle('hidden', !busy);
      }

      onClick(event) {
        if (this.busy || !this.state.variant) return;
        const chosen = this.selectedVariant();
        if (!chosen || !chosen.available) {
          this.errorEl.textContent = 'Diese Kombination ist leider nicht verfügbar.';
          this.errorEl.hidden = false;
          return;
        }
        const variantId = String(chosen.id);
        this.setBusy(true);

        // Warenkorbseite oder Drawer: vorhandene Mengenänderung des Themes verwenden
        const cartItems =
          this.dataset.context === 'drawer'
            ? document.querySelector('cart-drawer-items')
            : this.dataset.context === 'page'
            ? document.querySelector('cart-items')
            : null;
        if (cartItems && variantId !== String(this.state.variant)) {
          // Andere Farbe/Größe: neu hinzufügen und Warenkorb neu laden
          fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
          })
            .then((r) => r.json())
            .then((res) => {
              if (res.status) throw new Error(res.description || '');
              this.userPicked = false;
              if (this.dataset.context === 'drawer' && typeof cartItems.onCartUpdate === 'function') {
                return Promise.resolve(cartItems.onCartUpdate()).then(() => {
                  if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell' });
                });
              }
              window.location.reload();
            })
            .catch((e) => {
              this.errorEl.textContent = (e && e.message) || window.cartStrings?.error || '';
              this.errorEl.hidden = false;
            })
            .finally(() => this.setBusy(false));
          return;
        }
        if (cartItems && typeof cartItems.updateQuantity === 'function') {
          cartItems.updateQuantity(1, this.state.qty + 1, event, null, this.state.variant);
          // Die Theme-Funktion rendert Liste/Summen neu und löst "cart-update" aus
          setTimeout(() => this.setBusy(false), 1200);
          return;
        }

        // Bestätigungs-Pop-up / sonst: /cart/add wie der normale Button
        const notification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = { items: [{ id: Number(variantId), quantity: 1 }] };
        if (notification) {
          body.sections = notification.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }
        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((response) => {
            if (response.status) {
              this.errorEl.textContent = response.description || window.cartStrings?.error || '';
              this.errorEl.hidden = false;
              return;
            }
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', productVariantId: variantId, cartData: response });
            }
            this.userPicked = false;
            const first = response.items?.[0] || {};
            if (notification) notification.renderContents({ ...response, key: first.key, id: first.id });
            else window.location = window.routes.cart_url;
          })
          .catch(() => {
            this.errorEl.textContent = window.cartStrings?.error || '';
            this.errorEl.hidden = false;
          })
          .finally(() => this.setBusy(false));
      }
    }
  );
}
